import { useSmallScreen } from '@/hooks/useWindowDimension';
import legendClasses from '@/views/map/MapLayerManager/MapLayerLegend.module.css';
import classes from './SegmentationLegend.module.css';

export const SegmentationLegend = () => {
  const isSmallScreen = useSmallScreen();
  return (
    <div className={legendClasses.legend} data-testid="segmentation-legend">
      {!isSmallScreen && (
        <div className={legendClasses.legendTitle} id="treecover-segmentation">
          Tree cover by segmentation
        </div>
      )}
      <span className={classes.indicator} />
      Tree canopy
    </div>
  );
};
